// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1vQ58","legacyBtn":"MutateMid_legacyBtn__Z3m0p"};